/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value2: "",
    value3a: "",
    value3b: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    value8: "",
    value9: "",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3a: "",
      value3b: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 50 }}>
                STT
                <div className="button-action">
                  <button onClick={handleAdd} type="button">
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tên người nộp lệ phí hoặc tên địa điểm kinh doanh
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Địa chỉ (Ghi rõ địa chỉ quận/huyện, tỉnh/thành phố)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế người nộp lệ phí hoặc mã số địa điểm kinh doanh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Vốn điều lệ hoặc vốn đầu tư
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mức lệ phí môn bài
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền lệ phí môn bài phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền lệ phí môn bài được miễn
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Trường hợp miễn lệ phí môn bài (Ghi trường hợp được miễn theo quy định)
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tỉnh/ thành phố
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Quận/ huyện
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)=(6)-(8)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (9)
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                1
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Người nộp lệ phí môn bài
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                1
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Nguyễn Văn A
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                <select
                  style={selectStyle}
                  // onChange={(e) =>
                  //   handleChange({ id: item.id, name: "value3a", value: e.target.value })
                  // }
                >
                  <option value="value1">Tp Hồ Chí Minh</option>
                  <option value="value2">Tp Cần Thơ</option>
                </select>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                <select
                  style={selectStyle}
                  // onChange={(e) =>
                  //   handleChange({ id: item.id, name: "value3b", value: e.target.value })
                  // }
                >
                  <option value="value1">Tp Hồ Chí Minh</option>
                  <option value="value2">Tp Cần Thơ</option>
                </select>
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                0311854915
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                <InputTable name="value4" value="" />
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                <select
                  style={selectStyle}
                  // onChange={(e) =>
                  //   handleChange({ id: item.id, name: "value3b", value: e.target.value })
                  // }
                >
                  <option value="value1">1.000.000đ</option>
                  <option value="value2">500.000</option>
                </select>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                <select
                  style={selectStyle}
                  // onChange={(e) =>
                  //   handleChange({ id: item.id, name: "value3b", value: e.target.value })
                  // }
                >
                  <option value="value1">Tổ chức nuôi trồng, đánh bắt thủy, hải sản</option>
                  <option value="value2">Điểm bưu điện văn hóa xã</option>
                </select>
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                2
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Địa điểm kinh doanh (ghi rõ tên)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  rowSpan={1}
                  style={{ textAlign: "center", background: "#ddeff3" }}
                >
                  2.{index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value3a", value: e.target.value })
                    }
                  >
                    <option value="value1">Tp Hồ Chí Minh</option>
                    <option value="value2">Tp Cần Thơ</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value3b", value: e.target.value })
                    }
                  >
                    <option value="value1">Tp Hồ Chí Minh</option>
                    <option value="value2">Tp Cần Thơ</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    name="value4"
                    id={item.id}
                    type="text"
                    value={item.value4}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value6", value: e.target.value })
                    }
                  >
                    <option value="value1">1.000.000đ</option>
                    <option value="value2">500.000</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value9", value: e.target.value })
                    }
                  >
                    <option value="value1">Tổ chức nuôi trồng, đánh bắt thủy, hải sản</option>
                    <option value="value2">Điểm bưu điện văn hóa xã</option>
                  </select>
                </Td>
              </tr>
            ))}
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}>
                Tổng cộng các địa điểm kinh doanh:
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}
              >
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}>
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}
              >
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
            Thêm dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
